<template>
  <div class="row" v-if="showChat">
    <div class="col">
      <h2>Chat</h2>
      <iframe style="border: none;" :src="iframeSrc" v-if="iframeSrc" width="100%" height="400"></iframe>
    </div>
  </div>
</template>

<script>
  import services from '../service/api'

  export default {
    name: "Chat",
    props:[],
    data() {
      return {
        iframeSrc: null,
        showChat:window.config.site.chat
      }
    },
    mounted() {
      let self = this;
      if(self.showChat){
        services.getTokenChat().then(function (response) {
          if (response.data.result.data) {
            self.iframeSrc = window.config.CHAT_URL + "chat?token=" + response.data.result.data;
          }
        }).catch(function (err) {
          console.error(err);
        })
      }
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Chat.vue